
export const boxStyles = { display: "flex", flexDirection: "column", minHeight: "100vh" }
export const mainStyles = {
   
    paddingTop: 3,
    paddingBottom: 3,
    transition: "background-color 0.3s ease-in-out", 
  }